module.exports = __webpack_public_path__ + "img/icon_sb_unselect_star_ekomi_t.086c47b.svg";